import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import NavBar from '../NavBar';
import { Icon, IconButton, Svg } from '@ohif/ui';
import { ScrollArea, ScrollBar } from '../ScrollArea';
import { Separator } from '../Separator';

import logoOnics from './../../../../app/public/assets/favicon-32x32.png';

// Todo: we should move this component to composition and remove props base

interface HeaderProps {
  children?: ReactNode;
  menuOptions: Array<{
    title: string;
    icon?: string;
    onClick: () => void;
  }>;
  isReturnEnabled?: boolean;
  onClickReturnButton?: () => void;
  isSticky?: boolean;
  WhiteLabeling?: {
    createLogoComponentFn?: (React: any, props: any) => ReactNode;
  };
  PatientInfo?: ReactNode;
  Secondary?: ReactNode;
}

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  PatientInfo,
  Secondary,
  ...props
}: HeaderProps): ReactNode {
  const { t } = useTranslation('Header');

  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      {/* <div className="flex h-[36px] items-center justify-between sm:hidden">
        <div className="text-primary-light ml-1 flex items-center justify-start gap-1 sm:hidden">
          <img
            src={logoOnics}
            alt="logo"
            width={25}
          />{' '}
          <span>ONICS</span>
        </div>
        <div className="flex items-center justify-end sm:hidden">{PatientInfo}</div>
      </div>
      <Separator className="flex sm:hidden" /> */}
      <div className="flex h-[36px] items-center justify-between">
        {/* Logo dan Return Button */}
        <div className="flex items-center justify-start sm:w-[100px]">
          {/* {isReturnEnabled && (
              <Icon
                name="chevron-left"
                className="text-primary-active w-8"
              />
            )} */}
          <div className="text-primary-light ml-1 flex items-center gap-1">
            <img
              src={logoOnics}
              alt="logo"
              width={25}
            />{' '}
            <span>ONICS</span>
            {/* <h2>ONICS</h2> */}
          </div>
        </div>
        {/* Menu Tools dengan ScrollArea */}
        {/* <div className="flex-1 justify-center"> */}
        <ScrollArea className="mx-2 max-h-[36px] w-full flex-1 items-center">
          <div className="flex items-center justify-center space-x-2">{children}</div>
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
        {/* </div> */}
        {/* Patient Info dan Settings */}
        <div className="hidden items-center justify-end sm:flex sm:w-[100px]">
          {/* {PatientInfo} */}
          {/* <div className="bg-primary-dark mx-2 h-[25px] w-px"></div> */}
          <IconButton
            id="preferences-button"
            variant="text"
            color="inherit"
            size="initial"
            className="text-primary-active hover:bg-primary-dark"
            onClick={() => menuOptions[1].onClick()}
            label={menuOptions[1].title}
          >
            <Icon name="icon-settings" />
          </IconButton>
        </div>
      </div>
    </NavBar>
  );
}

export default Header;
